/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "omg": {
        "nested": {
          "order_extensions": {
            "nested": {
              "discount_codes": {
                "nested": {
                  "RedemptionExtension": {
                    "fields": {
                      "expiresAt": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.omg?.nested?.order_extensions?.nested?.discount_codes?.nested?.RedemptionExtension) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RedemptionExtension @ squareup/omg/discount-codes/extensions.proto at 12:1
 */
export const RedemptionExtension = $root.lookupType('squareup.omg.order_extensions.discount_codes.RedemptionExtension');
fixType(RedemptionExtension);
Builder.createAndAttachToType(RedemptionExtension);